import Layout from "@/views/layout/layout";
const rootPath = "/acco";

const accounts = {
  path: rootPath,
  name: "accounts",
  description: "조회",
  redirect: rootPath + "/myAccounts",
  component: Layout,
  children: [
    {
      path: "myAccounts",
      name: "myAccounts",
      description: "계좌조회",
      component: () => import("@/views/templates/accounts/myAccounts"),
      props: () => ({ inAcnKnd: "0", inAcnDtlKnd: "0" }),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "transactionParents",
      name: "transactionParents",
      description: "거래내역조회",
      redirect: { name: "transactionDetails" },
      component: () => import("@/views/templates/accounts/transactionParents"),
      children: [
        {
          path: "transactionDetails",
          name: "transactionDetails",
          description: "거래내역조회",
          component: () => import("@/views/templates/accounts/transactionDetails"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "dfstlFxdepTrnhis",
          name: "dfstlFxdepTrnhis",
          description: "예금 거래내역조회",
          component: () => import("@/views/templates/accounts/dfstlFxdepTrnhis"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "instypFxdepTrnhis",
          name: "instypFxdepTrnhis",
          description: "적금 거래내역조회",
          component: () => import("@/views/templates/accounts/instypFxdepTrnhis"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "lnAcnTrnhis",
          name: "lnAcnTrnhis",
          description: "대출 거래내역조회",
          component: () => import("@/views/templates/accounts/lnAcnTrnhis"),
          meta: {
            roles: ["login"],
          },
        },
      ],
    },
    {
      path: "cacInqParents",
      name: "cacInqParents",
      redirect: { name: "cacInq" },
      description: "당좌수표조회",
      component: () => import("@/views/templates/accounts/cacInqParents"),
      children: [
        {
          path: "cacInq",
          name: "cacInq",
          description: "당좌수표조회",
          component: () => import("@/views/templates/accounts/cacInq"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "cacInqRes",
          name: "cacInqRes",
          description: "당좌수표결과조회",
          component: () => import("@/views/templates/accounts/cacInqRes"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
      ],
    },
    {
      path: "bnkChekInqParents",
      name: "bnkChekInqParents",
      redirect: { name: "bnkChekInq" },
      description: "은행수표조회",
      component: () => import("@/views/templates/accounts/bnkChekInqParents"),
      children: [
        {
          path: "bnkChekInq",
          name: "bnkChekInq",
          description: "은행수표조회",
          component: () => import("@/views/templates/accounts/bnkChekInq"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "bnkChekInqRes",
          name: "bnkChekInqRes",
          description: "은행수표결과조회",
          component: () => import("@/views/templates/accounts/bnkChekInqRes"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
      ],
    },
  ],
};

export default accounts;
